<script>
import axios from '@/utils/axios';

export default {
  emits: ['updated'],
  data() {
    return {
      challans: [],
      selected_challan_id: null,
      selected_challan: null,
      challan_items: [],
      remarks: '',
      document: null,
      submitting: false,
    };
  },

  methods: {

    async openReturn() {
      this.resetForm();
      await this.loadDispatchedChallans();
    },

    resetForm() {
      this.selected_challan_id = null;
      this.selected_challan = null;
      this.challan_items = [];
      this.remarks = '';
      this.document = null;
      this.submitting = false;
      if (this.$refs.documentInput) {
        this.$refs.documentInput.value = '';
      }
    },

    async loadDispatchedChallans() {
      try {
        const response = await axios.get('/inventory/delivery-challans?status=dispatched&per_page=100');
        this.challans = response.data.data.data || [];
      } catch (error) {
        console.log('Load challans error:', error.message);
      }
    },

    async onChallanSelect(val) {
      this.selected_challan_id = val;
      this.challan_items = [];
      this.selected_challan = null;

      if (!val) return;

      try {
        // Fetch DC details + existing returns in parallel
        const [dcResponse, returnsResponse] = await Promise.all([
          axios.get(`/inventory/delivery-challans/${val}`),
          axios.get(`/inventory/delivery-challan-returns?delivery_challan_id=${val}&per_page=100`),
        ]);

        const challan = dcResponse.data.data;
        this.selected_challan = challan;

        // Calculate already returned qty per delivery_challan_item_id
        const returnedQtyMap = {};
        const returns = returnsResponse.data.data?.data || returnsResponse.data.data || [];
        returns.forEach(ret => {
          (ret.return_items || []).forEach(ri => {
            const key = ri.delivery_challan_item_id;
            returnedQtyMap[key] = (returnedQtyMap[key] || 0) + parseFloat(ri.return_qty || 0);
          });
        });

        // Map challan items with remaining qty
        this.challan_items = (challan.challan_items || []).map(item => {
          const alreadyReturned = returnedQtyMap[item.id] || 0;
          const remainingQty = parseFloat(item.quantity || 0) - alreadyReturned;
          return {
            delivery_challan_item_id: item.id,
            item_name: item.name || item.item?.name || '-',
            item_code: item.item?.code || '',
            unit: item.item?.unit || item.unit || '-',
            original_qty: parseFloat(item.quantity || 0),
            already_returned: alreadyReturned,
            remaining_qty: remainingQty,
            return_qty: '',
            return_reason: '',
return_condition: '',
selected: false,
          };
        }).filter(item => item.remaining_qty > 0); // Hide fully returned items

      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    onFileChange(e) {
      this.document = e.target.files[0] || null;
    },

    selectedItemsCount() {
      return this.challan_items.filter(i => i.selected).length;
    },

    async submitReturn() {
      // Validate
      const selectedItems = this.challan_items.filter(i => i.selected);
      if (!this.selected_challan_id) {
        this.$swalToast('Please select a Delivery Challan.', 'error');
        return;
      }
      if (selectedItems.length === 0) {
        this.$swalToast('Please select at least one item to return.', 'error');
        return;
      }

      // Validate each selected item
      for (let i = 0; i < selectedItems.length; i++) {
        const item = selectedItems[i];
        if (!item.return_qty || parseFloat(item.return_qty) <= 0) {
          this.$swalToast(`Please enter return qty for ${item.item_name}.`, 'error');
          return;
        }
        if (parseFloat(item.return_qty) > item.remaining_qty) {
          this.$swalToast(`Return qty cannot exceed remaining qty (${item.remaining_qty}) for ${item.item_name}.`, 'error');
          return;
        }
        if (!item.return_reason.trim()) {
          this.$swalToast(`Please enter return reason for ${item.item_name}.`, 'error');
          return;
        }
      }

      this.submitting = true;
      try {
        const formData = new FormData();
        formData.append('remarks', this.remarks || '');

        if (this.document) {
          formData.append('document', this.document);
        }

        selectedItems.forEach((item, index) => {
          formData.append(`items[${index}][delivery_challan_item_id]`, item.delivery_challan_item_id);
          formData.append(`items[${index}][return_qty]`, item.return_qty);
          formData.append(`items[${index}][return_reason]`, item.return_reason);
          formData.append(`items[${index}][return_condition]`, item.return_condition);
        });

        const response = await axios.post(
          `/inventory/delivery-challan-returns/dc/${this.selected_challan_id}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        this.$swalToast(response.data.message || 'Return DC created successfully.');
        this.$closeModal('return_dc_modal');
        this.$emit('updated');
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          const firstError = Object.values(error.response.data.errors)[0];
          this.$swalToast(Array.isArray(firstError) ? firstError[0] : firstError, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.submitting = false;
      }
    },

    recipientName(challan) {
      if (!challan) return '';
      if (challan.recipient_type === 'App\\Models\\Customer') {
        return challan.recipient?.company_name || challan.recipient?.name || challan.recipient_details?.name || '';
      }
      if (challan.recipient_type === 'App\\Models\\WorkOrder') {
        return challan.recipient?.name || challan.recipient_details?.name || '';
      }
      return challan.recipient?.user?.name || challan.recipient_details?.name || '';
    },

    challanLabel(challan) {
      const recipient = this.recipientName(challan);
      return `${challan.challan_number}${recipient ? ' — ' + recipient : ''}`;
    },

  },
};
</script>

<template>
  <div class="modal fade" id="return_dc_modal" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title fw-bold">
            <i class="ti ti-arrow-back-up me-2"></i>Create Return DC
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" :disabled="submitting"></button>
        </div>

        <div class="modal-body">

          <!-- Step 1: Select Delivery Challan -->
          <div class="mb-3">
            <label class="form-label fw-semibold">Select Delivery Challan <span class="text-danger">*</span></label>
            <vue-select 
              :options="challans"
              :reduce="c => c.id"
              :get-option-label="c => challanLabel(c)"
              placeholder="Search & select a dispatched challan..."
              @update:modelValue="onChallanSelect"
              v-model="selected_challan_id"
            />
          </div>

          <!-- Challan Info -->
          <div v-if="selected_challan" class="alert alert-light border mb-3 py-2">
            <div class="row">
              <div class="col-sm-4">
                <small class="text-muted d-block">Challan No</small>
                <span class="fw-semibold">{{ selected_challan.challan_number }}</span>
              </div>
              <div class="col-sm-4">
                <small class="text-muted d-block">Recipient</small>
                <span>{{ recipientName(selected_challan) }}</span>
              </div>
              <div class="col-sm-4">
                <small class="text-muted d-block">Warehouse</small>
                <span>{{ selected_challan.warehouse?.name || '-' }}</span>
              </div>
            </div>
          </div>

          <!-- Step 2: Items Table -->
          <div v-if="challan_items.length" class="mb-3">
            <label class="form-label fw-semibold">Select Items to Return <span class="text-danger">*</span></label>
            <div class="table-responsive">
              <table class="table table-bordered table-sm mb-0 align-middle">
                <thead class="table-light">
                  <tr>
                    <th style="width:40px;" class="text-center">
                      <i class="ti ti-checkbox"></i>
                    </th>
                    <th>Item</th>
                    <th style="width:80px;" class="text-center">Sent</th>
                    <th style="width:80px;" class="text-center">Returned</th>
                    <th style="width:80px;" class="text-center">Remaining</th>
                    <th style="width:100px;" class="text-center">Return Qty</th>
                    <th style="width:200px;">Return Reason</th>
                    <th style="width:130px;">Return Condition</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in challan_items" :key="item.delivery_challan_item_id" :class="item.selected ? 'table-warning' : ''">
                    <td class="text-center">
                      <input class="form-check-input" type="checkbox" v-model="item.selected" />
                    </td>
                    <td>
                      <span class="fw-semibold">{{ item.item_name }}</span>
                      <small v-if="item.item_code" class="text-muted d-block">{{ item.item_code }}</small>
                    </td>
                    <td class="text-center">
                      <span class="badge bg-light text-dark border">{{ item.original_qty }}</span>
                    </td>
                    <td class="text-center">
                      <span v-if="item.already_returned > 0" class="badge bg-success-subtle text-success">{{ item.already_returned }}</span>
                      <span v-else class="text-muted">0</span>
                    </td>
                    <td class="text-center">
                      <span class="badge bg-warning-subtle text-warning fw-bold">{{ item.remaining_qty }}</span>
                    </td>
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm text-center" 
                        v-model="item.return_qty" 
                        :disabled="!item.selected"
                        :max="item.remaining_qty"
                        min="1"
                        step="1"
                        placeholder="0"
                      />
                    </td>
<td>
  <select 
    class="form-select form-select-sm" 
    v-model="item.return_reason" 
    :disabled="!item.selected">
    <option value="">Select Reason</option>
    <option value="Damaged Item">Damaged Item</option>
    <option value="Defective Product">Defective Product</option>
    <option value="Wrong Item Delivered">Wrong Item Delivered</option>
    <option value="Quantity Mismatch">Quantity Mismatch</option>
    <option value="Quality Not as Expected">Quality Not as Expected</option>
    <option value="Order Cancelled / Not Required">Order Cancelled / Not Required</option>
  </select>
</td>
<td>
  <select 
    class="form-select form-select-sm" 
    v-model="item.return_condition" 
    :disabled="!item.selected">
    <option value="">Select</option>
    <option value="good">Good</option>
    <option value="faulty">Faulty</option>
  </select>
</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- No items message -->
          <div v-if="selected_challan_id && !challan_items.length" class="text-center text-muted py-4">
            <i class="ti ti-package-off fs-1 d-block mb-2 opacity-50"></i>
            <p class="mb-0">No returnable items found. All items may have been fully returned already.</p>
          </div>

          <!-- Remarks -->
          <div class="mb-3" v-if="selected_challan_id">
            <label class="form-label fw-semibold">Remarks</label>
            <textarea class="form-control" v-model="remarks" rows="2" placeholder="Optional remarks..."></textarea>
          </div>

          <!-- Document Upload -->
          <div class="mb-3" v-if="selected_challan_id">
            <label class="form-label fw-semibold">Attach Document</label>
            <input type="file" class="form-control" ref="documentInput" @change="onFileChange" />
            <small class="text-muted">Optional — attach any supporting document.</small>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="submitting">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submitReturn()" :disabled="submitting || !selected_challan_id || selectedItemsCount() === 0">
            <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
            {{ submitting ? 'Creating...' : 'Create Return DC' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>